module.exports = __webpack_public_path__ + "static/media/oil-can.06d255f0.svg";